export default __webpack_public_path__ + "static/media/no-flight.cd00afb0.png";